import { write, read } from '@/lib/firebase';

const mappingsPath = (householdId) => `households/${householdId}/budget/categoryMappings`;

export const mappingService = {
  async load(householdId) {
    const val = await read(mappingsPath(householdId));
    return val || {};
  },

  async save(householdId, mappings) {
    await write(mappingsPath(householdId), mappings);
  },
};
